module.exports = __webpack_public_path__ + "static/media/login-screen.4fea5081.jpeg";